import React from 'react';

import { SupplyInputBase, SupplyInputBaseProps } from '@/widgets/Modals';

type SupplyInputProps<T> = T &
    SupplyInputBaseProps & {
        tooltipText?: string;
    };

export const SupplyInput = <T,>({
    tooltipText = 'The annual percentage yield you earn from supplying assets to the pool.',
    ...props
}: SupplyInputProps<T>) => {
    return <SupplyInputBase label='Supply APY' tooltipText={tooltipText} {...props} />;
};
